// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".keyboard-item[data-v-5d55371f]{width:50px;height:50px;background-color:#354052;border:1px solid #212833;display:flex;justify-content:center;align-items:center;color:#fff;border-radius:0;box-shadow:none;outline:none}.keyboard-item[data-v-5d55371f]:hover{background-color:#404d62;font-size:120%}.keyboard-item[data-v-5d55371f]:focus{box-shadow:none;outline:none}.keyboard-item[data-v-5d55371f]:active{background-color:#4f5f79}", ""]);
// Exports
module.exports = exports;
